/*
 * video-lazyplay.js — scroll-triggered playback for <video data-lazy-video>.
 *
 * P1-2: instead of `autoplay` (which forces the browser to download the whole
 * video on page load), these videos ship with preload="none" + a poster and
 * stay idle until they scroll into view. play() then triggers the download, so
 * nothing is fetched before it is actually needed. Playback requires the video
 * to be muted (browser autoplay policy) — the markup keeps `muted`.
 */
(function () {
  function init() {
    var videos = document.querySelectorAll('video[data-lazy-video]');
    if (!videos.length) return;

    // No IntersectionObserver (very old browsers): fall back to play on load.
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(videos, function (v) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            var p = video.play();
            if (p && p.catch) p.catch(function () {}); // ignore autoplay-policy rejections
          } else if (!video.paused) {
            video.pause();
          }
        });
      },
      { threshold: 0.25 }
    );

    Array.prototype.forEach.call(videos, function (v) {
      observer.observe(v);
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
